import React, { useState, useEffect } from "react";
import Header from "../nav/Header";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardActions,
  CardImage,
  CardSubtitle,
} from "@progress/kendo-react-layout";

function Medics() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const dataFromServer = await fetchData();
      setData(dataFromServer);
    };
    getData();
  }, []);

  //Fetch Guides from API
  const fetchData = async () => {
    const res = await fetch("https://saraiapp.com/api/allmedics");
    const data = await res.json();
    //console.warn(data)
    return data;
  };
  //replace html tags in the data sent from DB
  //const replaceTags = /(<([^>]+)>)/ig

  return (
    <React.Fragment>
      <Header />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">Medical Personels</h1>
            <h2 className="sub-header mt-0">
              Find listed Nurses, Midwives and Doctors
            </h2>
          </div>
        </div>
        <div className="row">
          {data.map((item) => (
            <div className="col-4 mb-3" key={item.id}>
              <Card>
                <CardImage
                  src={"https://saraiapp.com/" + item.media}
                  alt={item.firstName + item.lastName}
                />
                <div>
                  <CardHeader>
                    <CardTitle>
                      {item.title + " " + item.firstName + " " + item.lastName}
                    </CardTitle>
                    <CardSubtitle>
                      <span className="reviews">
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span className="k-icon k-i-star-outline" />
                        {/*<div>4/5 (681)</div>*/}
                      </span>
                    </CardSubtitle>
                  </CardHeader>
                  <CardBody>
                    <p>
                      <strong>About me: </strong>
                      {item.about}
                    </p>
                  </CardBody>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Medics;
